import { defineMessage } from 'magpie-lib/models';
import * as t from 'ts-schema';
export const streamingPublishMessage = defineMessage({
  type: '@assistant/streaming',
  payloadSchema: t.object({
    isStreaming: t.boolean
  })
});